import { isAutoMappedNegotiacaoVariable } from '@/shared/utils/agentVariables';

import type { Flow, FlowVariable } from '../types';

/**
 * Campos que a criação pede à pessoa. O catálogo publicado já devolve as variáveis do agente com
 * `requestOnCreate` decidido no servidor, então o front não deriva nada dos nós do fluxo.
 * O lote usa `claimAmount` para exigir o valor; os formulários o omitem dos demais auto mapeados.
 */
export function derivarParametrosDoAgente(selectedAgent: Flow | null): FlowVariable[] {
  return (selectedAgent?.definition.variables ?? []).filter(
    (variable) =>
      variable.requestOnCreate === true &&
      (variable.name === 'claimAmount' || !isAutoMappedNegotiacaoVariable(variable.name)),
  );
}
